import { useRef } from "react";
import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type {
	CompanyDealDashboard,
	DealDashboardCondition
} from "~/models/DealDashboard";
import { convertQueryStringUrl } from "~/utils/DealSearchConditionUtils";

const paths = {
	index: "/homes"
};

export const useHomes = (
	query: DealDashboardCondition
): SwrReturnType<CompanyDealDashboard> => {
	const cachedDataRef = useRef<CompanyDealDashboard | null>(null);
	const { data, mutate, error, isLoading } = useSWR<CompanyDealDashboard>(
		convertQueryStringUrl(paths.index, query)
	);

	if (data) {
		cachedDataRef.current = data;
	}

	return {
		data: data ?? cachedDataRef.current,
		error,
		isLoading,
		mutate
	};
};
